import React from "react";
import style from "./Content.module.css";
import LinkGen from "../../LinkGen";
import {
  FaUserAlt as User,
  FaClock as Clock,
  FaShareAlt as Share,
} from "react-icons/fa";
function Content({ data }) {
  return (
    <div className={style.mainContainer}>
      <div className={style.wrapper}>
        <div className={style.headingDiv}>
          <h1 className={style.heading}>{data.title}</h1>
          <div className={style.detailDiv}>
            <div className={style.author}>
              <User className={style.icon} />
              {data.author}
            </div>
            <div className={style.date}>
              <Clock className={style.icon} />
              {data.date}
            </div>

            <div className={style.share}>
              <Share className={style.icon} />
              Share
            </div>
          </div>
          <img
            src="https://invozone.com/wp-content/uploads/2020/07/how-software-development-integrate-lean-principles.jpg"
            className={style.fig}
            alt=""
          ></img>
          <div className={style.tableContent}>
            <span className={style.contentHeading}>Table of Contents</span>
            <ol className={style.nestedCounterList}>
              {data.contents.map(
                (contents, index) => (
                  <li key={index}>
                    <a href={`#${LinkGen(contents.heading)}`}>
                      {contents.heading}
                    </a>
                    <ol key={index}>
                      {contents.subContents.map(
                        (subContent, index) => (
                          <React.Fragment key={index}>
                            {subContent.heading !== "" && (
                              <li key={index}>
                                <a href={`#${LinkGen(subContent.heading)}`}>
                                  {subContent.heading}
                                </a>
                              </li>
                            )}
                          </React.Fragment>
                        ),
                        []
                      )}
                    </ol>
                  </li>
                ),
                []
              )}
            </ol>
          </div>
          <div className={style.descriptionPara}>{data.desc}</div>
          <div className={style.contentDesc}>
            {data.contents.map(
              (content, index) => (
                <div key={index} className={style.paraWrapper}>
                  <p className={style.mainPara} id={LinkGen(content.heading)}>
                    <span className={style.headingDescPara}>
                      {content.heading}
                    </span>
                    <span className={style.descDescPara}>
                      {content.description}
                    </span>
                  </p>
                  {content.subContents.map(
                    (subContent, index) => (
                      <React.Fragment key={index}>
                        {subContent.heading !== "" && (
                          <p
                            key={index}
                            className={style.subPara}
                            id={LinkGen(subContent.heading)}
                          >
                            <span className={style.headingSubPara}>
                              {subContent.heading}
                            </span>
                            <span className={style.descSubPara}>
                              {subContent.description}
                            </span>
                          </p>
                        )}
                      </React.Fragment>
                    ),
                    []
                  )}
                </div>
              ),
              []
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Content;
